import React from 'react';
import { motion } from 'framer-motion';
import { METRICS } from '../../utils/metricConfig';
import { useMetricParam } from '../../hooks/useMetricParam';
export function MetricSelector() {
  const [metric, setMetric] = useMetricParam();
  return <div role="tablist" aria-label="Dashboard metric" className="-mb-px flex gap-0.5 overflow-x-auto" data-id="element-76" data-mp="nmzcktsa7tv3">
      {METRICS.map(m => {
      const active = m.id === metric;
      return <button key={m.id} type="button" role="tab" aria-selected={active} onClick={() => setMetric(m.id)} className={`relative whitespace-nowrap rounded-t-md px-4 py-2.5 text-[13.5px] font-semibold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-navy/30 ${active ? 'bg-canvas text-navy' : 'text-ink-muted hover:bg-canvas/60 hover:text-ink'} ${m.id === 'retention' ? 'ml-3 border-l border-line pl-5' : ''}`} data-id="element-77" data-mp="1galhc5d8x4jj">
            {m.label}
            {active && <motion.span layoutId="metric-underline" className="absolute inset-x-2 bottom-0 h-[3px] rounded-t bg-accent" transition={{
          duration: 0.2,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-78" data-mp="fw81h66mwvp8" />}
          </button>;
    })}
    </div>;
}